import React from 'react';

import TrustpilotReviews from '../TrustpilotReviews/';

import FooterBlock from './components/FooterBlock';

const TrustPilotFooter = () => (
  <FooterBlock>
    <TrustpilotReviews theme="minimal" isExternalLink hideScore />
  </FooterBlock>
);

export default TrustPilotFooter;
